/**
 * 간소화된 인증 컨텍스트
 * SimpleVsCodeAuthHandler를 사용하여 복잡성 제거
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
// User 타입은 types-auth에서 import (types-user에는 UserProfile만 있음)
import { isVSCodeEnvironment } from '../utils/navigation';
import { SimpleVsCodeAuthHandler } from '../handlers/simple-vscode';
// 기본값
var defaultAuthContext = {
    isAuthenticated: false,
    user: null,
    token: null,
    isLoading: true,
    error: null,
    logout: /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            console.warn('AuthProvider not initialized');
            return [
                2
            ];
        });
    }),
    refreshAuth: /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            console.warn('AuthProvider not initialized');
            return [
                2
            ];
        });
    }),
    fetchUserEmail: /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            console.warn('AuthProvider not initialized');
            return [
                2,
                undefined
            ];
        });
    })
};
export var SimpleAuthContext = /*#__PURE__*/ createContext(defaultAuthContext);
export var SimpleAuthProvider = function(param) {
    var children = param.children, ideMessagingService = param.ideMessagingService;
    var _useState = _sliced_to_array(useState({
        isAuthenticated: false,
        user: null,
        token: null,
        isLoading: true,
        error: null
    }), 2), authState = _useState[0], setAuthState = _useState[1];
    var authHandlerRef = useRef(null);
    var ideMessengerInstance = ideMessagingService || null;
    var isVSCodeEnv = isVSCodeEnvironment();
    // VSCode 환경에서만 핸들러 초기화
    useEffect(function() {
        if (isVSCodeEnv && ideMessengerInstance) {
            console.log('[SimpleAuthProvider] VSCode 환경 - SimpleVsCodeAuthHandler 초기화');
            var handler = new SimpleVsCodeAuthHandler(ideMessengerInstance);
            authHandlerRef.current = handler;
            // 상태 변경 리스너 등록
            handler.addStateChangeListener(function(newState) {
                console.log('[SimpleAuthProvider] 인증 상태 변경:', newState);
                setAuthState(newState);
            });
            // 초기화
            handler.initialize().catch(function(error) {
                console.error('[SimpleAuthProvider] 핸들러 초기화 실패:', error);
            });
            return function() {
                // 정리
                if (authHandlerRef.current) {
                    authHandlerRef.current.removeStateChangeListener(function() {});
                }
            };
        } else if (!isVSCodeEnv) {
            // 웹 환경에서는 기존 WebAuthHandler 사용 (간소화 필요시 별도 작업)
            console.log('[SimpleAuthProvider] 웹 환경 - WebAuthHandler 사용 (향후 간소화 예정)');
            setAuthState(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    isLoading: false
                });
            });
        } else {
            console.warn('[SimpleAuthProvider] VSCode 환경이지만 IdeMessenger가 없습니다.');
            setAuthState(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    isLoading: false,
                    error: 'VSCode 환경 초기화 실패'
                });
            });
        }
    }, [
        isVSCodeEnv,
        ideMessengerInstance
    ]);
    // VSCode 세션 변경 이벤트 리스너
    useEffect(function() {
        var _ideMessengerInstance_onMessage;
        if (!ideMessengerInstance || !isVSCodeEnv) return;
        var handleSessionChange = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(data) {
                var error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.log('[SimpleAuthProvider] VSCode 세션 변경 이벤트 수신:', data);
                            if (!authHandlerRef.current) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                authHandlerRef.current.refreshAuthState()
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error('[SimpleAuthProvider] 세션 변경 처리 중 오류:', error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleSessionChange(data) {
                return _ref.apply(this, arguments);
            };
        }();
        // Register listener with ideMessagingService if available
        var cleanup = (_ideMessengerInstance_onMessage = ideMessengerInstance.onMessage) === null || _ideMessengerInstance_onMessage === void 0 ? void 0 : _ideMessengerInstance_onMessage.call(ideMessengerInstance, 'didChangeControlPlaneSessionInfo', handleSessionChange);
        return cleanup;
    }, [
        ideMessengerInstance,
        isVSCodeEnv
    ]);
    // 로그아웃 함수
    var logout = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log('[SimpleAuthProvider] 로그아웃 시작');
                    if (!authHandlerRef.current) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        authHandlerRef.current.logout()
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    if (!isVSCodeEnv) {
                        // 웹 환경에서는 WebAuthHandler 사용
                        // 향후 웹용 간소화된 핸들러로 교체 예정
                        console.log('[SimpleAuthProvider] 웹 환경 로그아웃 (WebAuthHandler 사용)');
                    }
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        isVSCodeEnv
    ]);
    // 인증 새로고침 함수
    var refreshAuth = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log('[SimpleAuthProvider] 인증 새로고침 시작');
                    if (!authHandlerRef.current) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        authHandlerRef.current.refreshAuthState()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), []);
    // 사용자 이메일 가져오기 (향후 SimpleVsCodeAuthHandler로 이동 예정)
    var fetchUserEmail = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            console.log('[SimpleAuthProvider] 사용자 이메일 가져오기 (미구현)');
            return [
                2,
                undefined
            ];
        });
    }), []);
    // 컨텍스트 값
    var contextValue = _object_spread_props(_object_spread({}, authState), {
        logout: logout,
        refreshAuth: refreshAuth,
        fetchUserEmail: fetchUserEmail
    });
    return /*#__PURE__*/ React.createElement(SimpleAuthContext.Provider, {
        value: contextValue
    }, children);
};
/**
 * 간소화된 인증 컨텍스트 사용 훅
 */ export var useSimpleAuth = function() {
    var context = useContext(SimpleAuthContext);
    if (!context) {
        throw new Error('useSimpleAuth must be used within a SimpleAuthProvider');
    }
    return context;
};
